module.exports = __webpack_public_path__ + "static/media/BS_O_Fashion_Sempione.92b5f2e2.png";